module.exports = __webpack_public_path__ + "img/liberty.80bf7ef1.svg";